import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DateRange} from '@angular/material/datepicker';
import moment from 'moment';
import {take} from 'rxjs';
import {filter} from 'rxjs/operators';

import {DateRangePickerDialogComponent, DateRangePickerDialogContext, DateRangePickerDto} from '../date-range-picker-dialog/date-range-picker-dialog.component';

@Component({
  selector: 'terra-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateRangePickerComponent implements OnInit {
  @Input() initialStartDate: Date = null;
  @Input() initialEndDate: Date = null;
  @Output() dateRangeSelected = new EventEmitter<DateRange<Date>>();
  private _EMPTY_RANGE_PLACEHOLDER = 'Filter by Date Range';
  rangePlaceholder = this._EMPTY_RANGE_PLACEHOLDER;
  showClearFilter = false;

  get isEmptyRange(): boolean {
    return this.rangePlaceholder === this._EMPTY_RANGE_PLACEHOLDER;
  }

  constructor(
    private dialog: MatDialog,
    private vcr: ViewContainerRef
  ) {
  }

  ngOnInit(): void {
  }

  selectDates() {
    const dialogWidth = 350;
    const dialogHeight = 320;
    const dialogConfig = new MatDialogConfig<DateRangePickerDialogContext>();
    dialogConfig.viewContainerRef = this.vcr;
    dialogConfig.autoFocus = true;
    dialogConfig.width = `${dialogWidth}px`;
    dialogConfig.maxWidth = `${dialogWidth}px`;
    dialogConfig.height = `${dialogHeight}px`;
    dialogConfig.maxHeight = `${dialogHeight}px`;
    dialogConfig.data = new DateRangePickerDialogContext();
    dialogConfig.data.initialStartDate = this.initialStartDate;
    dialogConfig.data.initialEndDate = this.initialEndDate;
    dialogConfig.position = this.setDialogPosition(this.vcr, dialogWidth, dialogHeight);

    return this.dialog.open(DateRangePickerDialogComponent, dialogConfig)
      .afterClosed().pipe(
        take(1),
        filter(result => result?.startDate && result?.endDate)
      ).subscribe((result: DateRangePickerDto) => {
          const start = result?.startDate;
          const end = result?.endDate;

          if (start || end) {
            this.showClearFilter = true;
            this.rangePlaceholder = `${moment(start).format('ll')}` +
              (moment(start).startOf('day').isBefore(moment(end).startOf('day')) ? ` - ${moment(end).format('ll')}` : ``);
          } else {
            this.showClearFilter = false;
            this.rangePlaceholder = this._EMPTY_RANGE_PLACEHOLDER;
          }

          this.dateRangeSelected.emit(new DateRange<Date>(start, end));
        }
      );
  }

  setDialogPosition(vcr: ViewContainerRef, dialogWidth: number, dialogHeight: number) {
    const wrapperPosition = vcr.element.nativeElement.getBoundingClientRect();
    const leftPos = wrapperPosition.left - dialogWidth + wrapperPosition.width;
    let topPos = wrapperPosition.bottom;
    if ((window.innerHeight - topPos - dialogHeight) < 0) {
      topPos = wrapperPosition.top - dialogHeight;
    }

    return {left: `${leftPos}px`, top: `${topPos}px`};
  }

  clearRange() {
    this.showClearFilter = false;
    this.rangePlaceholder = this._EMPTY_RANGE_PLACEHOLDER;
    this.dateRangeSelected.emit(new DateRange<Date>(null, null));
  }
}
